import PersonalAccountInfo from "./personal-account-info";
import EmployementInfo from "./employement-info";
import NomineeInfo from "./nominee-info";
import BankAccountInfo from "./bank-info";



export const PROFILE_SAVE_CTA = 'Save Changes';
export const PROFILE_EDIT_CTA = 'Edit Personal Details';
export const PROFILE_DISCARD_CTA = 'Discard';
export const PROFILE_ONBOARDING_CTA = 'Continue Onboarding';

export const PROFILE_TABS = [
    {
        key: '1',
        label: 'Personal Details',
        children: PersonalAccountInfo,
    },
    {
        key: '2',
        label: 'Bank Details',
        children: BankAccountInfo,
    },
    {
        key: '3',
        label: 'Employment Details',
        children: EmployementInfo,
    },
    {
        key: '4',
        label: 'Nominee Details',
        children: NomineeInfo,
    }
];

export const DASHBOARD_PERSONAL_INPUTS = [
    {
        name: "name",
        title: "Full Name",
        type: "text",
        placeholder: "Enter full name",
        disabled: true
    },
    {
        name: "primaryMobile",
        title: "Mobile Number",
        type: "number",
        placeholder: "Enter mobile number",
        disabled: true
    },
    {
        name: "gender",
        title: "Gender",
        type: "text",
        placeholder: "Enter your gender",
        disabled: true
    },
    {
        name: "dob",
        title: "DOB",
        type: "text",
        placeholder: "Enter your DOB",
        disabled: true
    },
    {
        name: "pan",
        title: "PAN Card Number",
        type: "text",
        placeholder: "Enter PAN Card number",
        disabled: true
    },
    {
        name: "taxStatus",
        title: "Tax Status",
        type: "text",
        placeholder: "Enter your tax status",
        disabled: true
    },
    {
        name: "aadhar",
        title: "Adhaar Number",
        type: "text",
        placeholder: "Enter aadhar number",
        disabled: true
    },
]

export const DASHBOARD_EMPLOYEMENT_INPUTS = [
    {
        name: "occupation",
        title: "Occupation Type",
        type: "text",
        placeholder: "Enter your occupation type",
        disabled: true
    },
    {
        name: "incomeSlab",
        title: "Income Range",
        type: "text",
        placeholder: "Enter your income range",
        disabled: true
    },
    {
        name: "idType",
        title: "ID Type",
        type: "text",
        placeholder: "Enter your ID type",
        disabled: true,
    },
    {
        name: "aadhar",
        title: "ID Number",
        type: "text",
        placeholder: "Enter your ID",
        disabled: true
    }
]
export const DASHBOARD_NOMINEE_INPUTS = [
    {
        name: "nomineeName",
        title: "Nominee Name",
        type: "text",
        placeholder: "Enter nominee name",
        disabled: true
    },
    {
        name: "relationship",
        title: "Relationship with Nominee",
        type: "text",
        placeholder: "Please select your relationship with nominee",
        disabled: true
    },
    {
        name: "nomineePercentage",
        title: "Nomination Percentage (%)",
        type: "number",
        placeholder: "Please enter nominee percentage",
        disabled: true
    },
]
export const DASHBOARD_BANK_INPUTS = [
    {
        name: "bankAccountNumber",
        title: "Account Number",
        type: "text",
        placeholder: "Enter account number",
        disabled: true
    },
    {
        name: "bankAccountType",
        title: "Account Type",
        type: "text",
        placeholder: "Enter account type",
        disabled: true
    },
    {
        name: "bankName",
        title: "Bank Name",
        type: "text",
        placeholder: "Enter bank name",
        disabled: true
    },
    {
        name: "branchName",
        title: "Bank Branch",
        type: "text",
        placeholder: "Enter branch name",
        disabled: true
    },
    {
        name: "ifscCode",
        title: "IFSC Code",
        type: "text",
        placeholder: "Enter IFSC code",
        disabled: true
    },
];

export const PROFILE_EDITABLE_FIELDS = {
    emailField: {
        title: 'Email ID',
        type: "email",
        placeholder: "Enter Email ID",
        rules: {
            required: "Please enter email id",
            pattern: {
                value: /^.+@[^.].*\.[a-z]{2,}$/,
                message: "Please enter a valid email"
            }
        }
    },
    addressField: {
        title: 'Address',
        type: "text",
        placeholder: "Enter address",
        rules: {
            required: "Please enter address",
            maxLength: {
                value: 40,
                message: "Please enter 40 characters only"
            }
        }
    },
    pinField: {
        title: 'Pincode',
        type: "number",
        placeholder: "Enter pincode",
        rules: {
            required: "Please enter your pincode",
        }
    },

}
export const PROFILE_MOBILE_TABS = [
    {
        title: 'Personal Details',
        icon: 'icon-account_login',
        path: 'profile/personal-info'
    },
    {
        title: 'Bank Details',
        icon: 'icon-bank',
        path: 'profile/bank-info'
    },
    {
        title: 'Employment Details',
        icon: 'icon-current_Address',
        path: 'profile/employment-info'
    },
    {
        title: 'Nominee Details',
        icon: 'icon-Nominee',
        path: 'profile/nominee-info'
    }
]


export const INCOME_SLABS: any = [
    { value: ['Below 1 Lakh', 'Below 1 Lac'], name: 'Below 1 Lakh' },
    { value: ['>1 <=5 Lacs', '1-5 Lacs'], name: 'Between 1 and 5 lakhs' },
    { value: ['>5 <=10 Lacs', '5-10 Lacs'], name: '5 to 10 lakhs' },
    { value: ['>10 <= 25 Lacs', '10-25 Lacs'], name: '10 to 25 lakhs' },
    { value: ['25 Lacs < = 1 Crore', '25 Lacs-1 crore'], name: '25 lakhs to 1 cr' },
    { value: ['Above 1 Crore', '>1 crore'], name: 'Above 1 cr' }
]

const NumberToWord = ['First', 'Second', 'Third', 'Fourth', 'Fifth'];

export const stringifyNumber = (num: number) => {
    if (num < 20) return NumberToWord[num];
}